export default __webpack_public_path__ + "static/media/Ballroll_00204.a7ad232a.png";